module.exports = __webpack_public_path__ + "img/logo-KTB.19cc08e.png";